import React, { Component } from 'react';
import { connect } from 'react-redux';
import FocusTrap from 'focus-trap-react';
import PropTypes from 'prop-types';
import { withFocusTrapContext } from '../checkout/contexts/FocusTrapContext';

// wraps react-focus-trap
class WrappedFocusTrap extends Component {
    componentDidMount() {
      if (this.props.id) {
        if (typeof this.registerFocusTrap === 'function') {
          this.unregisterFocusTrap = this.props.registerFocusTrap(this.props.id);
        }
      }
    }

    componentWillUnmount() {
      if (this.props.id) {
        if (typeof this.unregisterFocusTrap === 'function') {
          this.unregisterFocusTrap();
        }
      }
    }

    render() {
        if (!this.props.useFocusTrap) {
            return this.props.children;
        }

        const props = {...this.props};
        delete props.children;
        delete props.useFocusTrap;

        if (props.focusTrapOptions === undefined) {
            props.focusTrapOptions={};
        }
        props.focusTrapOptions.fallbackFocus = props.fallback;
        props.focusTrapOptions.allowOutsideClick = allowsOutsideClicks;

        const active = typeof this.props.active === 'boolean' && !this.props.active ? this.props.active : this.props.isActive;

        return (
            <FocusTrap
              {...props}
              active={active}
            >
                {this.props.children}
            </FocusTrap>
        )
    }
}

const classNames = ["onetrust", "privacy", "switch", "checkout__status-bar", "add-guarantee", "weather-guarantee", "hydrated"];
const ids = ["onetrust", "accept", "close-pc", "weather-guarantee","tg-placeholder"];

const allowsOutsideClicks = event => {
    const className = classNames.some(term => event.target.className?.includes(term));
    const id = ids.some(term => event.target.id?.includes(term));
    if (className || id){
        return true;
    }
    return false;
}

WrappedFocusTrap.propTypes = {
    fallback: PropTypes.any.isRequired,
};

const mapStateToProps = state => {
    return {
        useFocusTrap: !!state?.ui?.useFocusTrap,
    }
}

export default connect(mapStateToProps)(withFocusTrapContext(WrappedFocusTrap))

